module.exports = __webpack_public_path__ + "img/expedia.6d5ddd69.png";